import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import {
  Button,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Stack,
  TextareaAutosize,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import MDInput from 'components/MDInput'
import Multiselect from './components/Multiselect'

const CreateModal = ({ handleRefresh, Categories, Types, Tags, Dash_tags, business_types, staff }) => {
  const uploadImage = useUploadImage()
  const staffOptions = staff?.map(item => ({
    label: item?.username,
    value: item?._id,
  }))

  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const [user] = useUserInfo()

  const types = [
    { label: 'Agency', value: 'agency' },
    { label: 'Subaccount', value: 'sub_account' },
    { label: 'Agency & Subaccount', value: 'both' },
  ]

  const roadmapStatus = [
    { label: 'Wish List', value: 'wish-list' },
    { label: 'Planned', value: 'planned' },
    { label: 'In Progress', value: 'in-progress' },
    { label: 'Testing (Beta)', value: 'testing' },
    { label: 'Completed', value: 'completed' },
  ]

  const status = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
    { label: 'Beta', value: 'beta' },
  ]
  const integration_type = [
    { label: 'Auth', value: 'auth' },
    { label: 'Form', value: 'form' },
    { label: 'Url', value: 'url' },
  ]

  const FeaturesList = [
    { label: 'Snapshot', value: 'snapshot' },
    { label: 'Widget', value: 'widget' },
    { label: 'Custom Js', value: 'custom_js' },
    { label: 'Payment Provider', value: 'payment_provider' },
    { label: 'Actions', value: 'actions' },
    { label: 'Triggers', value: 'triggers' },
    { label: 'Conversation Providers', value: 'conversation_providers' },
  ]

  const handlemodal = () => {
    setOpenAddProduct(true)
  }

  useEffect(() => { }, [])

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [goingToLive, setGoingToLive] = useState(false)

    const handleCheckboxChange = (event) => {
      setGoingToLive(event.target.checked)
    }

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)
      const app_type = ''
      let image_response

      if (goingToLive) {
        image_response = await uploadImage({
          file: e.target?.image?.files?.[0],
          desiredPath: `app/logo/image`,
        })
      }



      function tryParseJSON(jsonString, defaultValue) {
        try {
          return jsonString ? JSON.parse(jsonString) : defaultValue
        } catch (error) {
          console.error('Failed to parse JSON:', error)
          return defaultValue
        }
      }

      const payload = {
        name: e.target.name?.value || '',
        description: e.target.description?.value || '',
        categories: tryParseJSON(e.target.categories?.value, []),
        video_url: e.target.video_url?.value || '',
        app_features: tryParseJSON(e.target.app_features?.value, []),
        status: tryParseJSON(e.target.status?.value, {}),
        roadmap_status: tryParseJSON(e.target.roadmap_status?.value, {}),
        image: image_response?.response?.data || null,
        app_triggers: Boolean(e.target.app_triggers?.checked),
        hasUIInterface: Boolean(e.target.hasUIInterface?.checked),
        user_id: user?._id || '',
        url: e.target.url?.value || '',
        custom_page: e.target.custom_page?.value || '',
        custom_page_for_all_the_app: e.target.custom_page_for_all_the_app?.value || '',
        custom_page_for_account_booster: e.target.custom_page_for_account_booster?.value || '',
        agency_custom_page: e.target.agency_custom_page?.value || '',
        dont_show: Boolean(e.target.dont_show?.checked),
        dont_show_location: Boolean(e.target.dont_show_location?.checked),
        included_all_the_apps: Boolean(e.target.included_all_the_apps?.checked),
        ...(e.target.distinguish_type?.value && {
          distinguish_type: tryParseJSON(e.target.distinguish_type.value, {}),
        }),
        ...(e.target.app_id?.value && { app_id: e.target.app_id.value }),
        ...(e.target.client_id?.value && { client_id: e.target.client_id.value }),
        ...(e.target.client_secret?.value && { client_secret: e.target.client_secret.value }),
        ...(e.target.sso?.value && { sso: e.target.sso.value }),
        ...(app_type === 'agency' && {
          ghlLocations_enable: Boolean(e.target.ghlLocations_enable?.checked),
          ghlusers_enable: Boolean(e.target.ghlusers_enable?.checked),
          ...(e.target.ghlLocations_enable?.checked && {
            location_modal_key: e.target.location_modal_key?.value || null,
            location_auth: Boolean(e.target.location_auth?.checked),
          }),
          ...(e.target.ghlusers_enable?.checked && {
            user_modal_key: e.target.user_modal_key?.value || null,
          }),
        }),
        app_type: {
          label: 'Subaccount',
          value: 'sub_account',
        },
        version_type: 'V3',
      }

      const { response } = await AppService.app.create({
        payload: payload,
      })
      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      height: '80vh',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }

    const closeAddProduct = () => {
      setOpenAddProduct(false)
    }

    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Register App
            </MDTypography>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" name="name" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Description
              </MDTypography>
              <MDBox>
                <TextareaAutosize
                  type="text"
                  name="description"
                  minRows={3}
                  style={{ width: '100%' }}
                />
              </MDBox>
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Categories
              </MDTypography>
              <Multiselect data={Categories} edit_data={[]} isMulti={true} name="categories" />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Type
              </MDTypography>
              <Multiselect data={Types} edit_data={[]} isMulti={true} name="distinguish_type" />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Video Url
              </MDTypography>
              <MDInput label="Video Url" name="video_url" fullWidth />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                App Features
              </MDTypography>
              <Multiselect data={FeaturesList} edit_data={[]} isMulti={true} name="app_features" />
            </MDBox>
            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Status
              </MDTypography>
              <Multiselect data={status} edit_data={[]} isMulti={false} name="status" />
            </MDBox>
            <MDBox sx={{ fontSize: '15px', marginTop: '10px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Roadmap Status
              </MDTypography>
              <Multiselect
                data={roadmapStatus}
                edit_data={[]}
                isMulti={false}
                name="roadmap_status"
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Form url
              </MDTypography>
              <MDInput label="url" name="url" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Custom Page
              </MDTypography>
              <MDInput label="custom_page" name="custom_page" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Custom Page For All The App 
              </MDTypography>
              <MDInput label="custom_page_for_all_the_app" name="custom_page_for_all_the_app" fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Custom Page For Account Booster
              </MDTypography>
              <MDInput label="custom_page_for_account_booster" name="custom_page_for_account_booster" fullWidth />
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Is App Have Triggers"
                  name="app_triggers"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Is App Have Trigger Interface"
                  name="hasUIInterface"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="mark as default alltheapps App"
                  name="default_app"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Is it included in all the apps"
                  name="included_all_the_apps"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label="Hide App"
                  name="dont_show"
                />
              </FormGroup>
            </MDBox>
            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={goingToLive}
                      onChange={handleCheckboxChange}
                      name="is_going_to_live"
                    />
                  }
                  label="App ready to publish"
                />
              </FormGroup>
            </MDBox>
            {goingToLive && (
              <>
                <hr />
                <MDBox
                  mt={2}
                  mb={2}
                  ml={0}
                  display="flex"
                  alignItems="start"
                  flexDirection="column"
                >
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    App Images
                  </MDTypography>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                      Upload Image +
                      <input hidden name="image" type="file" />
                    </Button>
                  </Stack>
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    App Id
                  </MDTypography>
                  <MDInput label="App Id" placeholder="App Id" name="app_id" fullWidth />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Client Id
                  </MDTypography>
                  <MDInput label="Client Id" placeholder="Client Id" name="client_id" fullWidth />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Client Secret
                  </MDTypography>
                  <MDInput
                    label="Client Secret"
                    placeholder="Client Secret"
                    name="client_secret"
                    fullWidth
                  />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    SSO Key
                  </MDTypography>
                  <MDInput label="SSO Key" placeholder="SSO Key" name="sso" fullWidth />
                </MDBox>
              </>
            )}


            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }

  return (
    <>
      <MDButton color="white" size="small" variant="contained" onClick={handlemodal}>
        Create
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal
